import { apiRequest } from '@/utils/api-request';

export const setOrgArchived = async (orgId: string, archived: boolean) => {
  const response = await apiRequest({
    url: `/organizations/${orgId}/archived`,
    method: 'PATCH',
    target: 'platform',
    body: { archived },
  });

  if (response?.detail) throw new Error(response.detail);

  return response;
};
